export const ERROR_STATUSES = {
  MAP: {
    ERROR: {
      RIGHTS: {
        CANNOT_EDIT: 'map.err.rights.cannot_edit',
        CANNOT_VIEW: 'map.err.rights.cannot_view',
        DOES_NOT_EXIST: 'map.err.rights.does_not_exist'
      },
      DELETED: 'map.err.deleted',
      NOT_EXIST: 'element_not_exists',
      AUTHORISATION_NOT_ENABLED: 'err.authorisation.authorisation_not_enabled',
      NO_READY_FOR_AUTHORISATIONS_DIAGRAMS: 'err.authorisation.no_diagrams_for_authorisation'
    }
  },

  ORGANIZATION: {
    NOT_FOUND: 'organization.not_found',
    SUSPENDED: 'team_suspended'
  },

  DIAGRAM: {
    ERROR: {
      LOCKED: 'diagram.err.locked',
      NOT_EXIST: 'diagram.version.not.exist',
      VERSION_RESTRICTED: 'err.diagram.version-restricted',
      RIGHTS: {
        CANNOT_EDIT: 'diagram_rights.cannot_edit',
        CANNOT_EDIT_NOTES: 'diagram_rights.cannot_edit_notes'
      },
      ATTACHMENT_WRONG_FORMAT: 'url_library.wrong_format_url_entry',

      ELEMENT_NOT_EXISTS: 'err.diagram.draw.element_not_exists',
      VALIDATION_FAILED: 'err.diagram.draw.validation_failed',
      KEY_ALREADY_EXISTS: 'err.diagram.draw.key_already_exists'
    }
  },

  USER: {
    ERROR: {
      USER_BLOCKED_IN_TEAM: 'user_in_team.blocked',
      ACCESS_DENIED: 'user.err.access-denied',
      NOT_PRO: 'team.err.is_not_pro',
      NOT_PRO_INFO: 'team.info.is_not_pro',
      USER_BLOCKED: 'user.err.blocked',
      USER_NOT_VERIFIED: 'user.err.user_is_not_verified',
      DELETED_BY_SYSTEM: 'user.err.deleted_from_system'
    }
  },

  IMPORT_DD: {
    ERROR: {
      NO_RIGHTS: 'import_drilldown.no_rights',
      NOT_EXIST: 'import_drilldown.source_map_not_exist'
    }
  },

  EXPORT_DD: {
    ERROR: {
      NO_RIGHTS: 'export_drilldown.no_rights',
      NOT_EXIST: 'export_drilldown.target_diagram_not_exist'
    }
  },

  CONNECTION: {
    ERROR: {
      NOT_THE_SAME_TEAM: 'connection.team.not.the.same'
    }
  },

  COMMENTS: {
    ERROR: {
      DUPLICATED_STATUS: 'comment.reply.duplicated_status',
      COMMENT_RESOLVED: 'comment.resolved'
    }
  },

  RESOURCES: {
    ERROR: {
      ALREADY_EXIST: 'already_exist'
    }
  },

  PERMISSIONS: {
    ERROR: {
      ALREADY_EDITOR: 'diagram_rights.user_already_editor_in_diagram',
      NOT_IN_MAP: 'diagram_rights.user_not_in_map'
    }
  },

  CHANGELOGS: {
    ERROR: {
      NOT_FOUND: 'changelog.list.nothing_found'
    }
  },

  TRAINING: {
    ERROR: {
      NO_TRAINING: 'training.err.no_training_task',
      TRAINING_CANCELLED: 'training.err.training_cancelled_by_owner',
      TRAINING_TASK_ITEM_CANCELLED: 'diagram_training.status_cancelled',
      TRAINING_SAME_STATUS: 'diagram_training.task.same_status'
    }
  },
  AUTHORISATION: {
    ERROR: {
      NO_AUTHORISATION: 'authorisation.err.authorisation_task'
    }
  }
} as const;
